import { CLIENT_CONDITIONS } from '~/permissions/client';
import { createPermissionContextProvider } from '~/permissions/lib/react/createPermissionContext';

export const [usePermissions, PermissionProvider] =
  createPermissionContextProvider(CLIENT_CONDITIONS);
